/* eslint-disable no-unused-vars */
export enum FontWeight {
    light = 300,
    normal = 400,
    medium = 500,
    semiBold = 600,
    bold = 700
}
